import { FC } from "react";
import { Navigate, Outlet } from "react-router";

import { ERoutes } from "../../constants/routes";
import { useAuth } from "../../hooks/useAuth";



const ProtectedRoute: FC = () => {
  const {
    isInitialized,
    isAuthenticated,
    isUnsignedUserRoute,
  } = useAuth();

  if (!isInitialized) {
    return null;
  }

  if (!isAuthenticated && !isUnsignedUserRoute) {
    return <Navigate to={ERoutes.Login} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
